import { render, staticRenderFns } from "./clientes.vue?vue&type=template&id=c1312ffe"
import script from "./clientes.vue?vue&type=script&lang=js"
export * from "./clientes.vue?vue&type=script&lang=js"
import style1 from "./clientes.vue?vue&type=style&index=1&id=c1312ffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports